// extracted by mini-css-extract-plugin
export default {"body":"body-WnBVp","inputContainer":"inputContainer-qqLka"};